export default __webpack_public_path__ + "efbb454a4bbfbe4c2aa875a9dfe082b8.svg";